import { Popover } from 'antd';
import { XLSX, PDF } from 'assets/images';
import PropTypes from 'prop-types';
import { RightOutlined } from '@ant-design/icons';
import { useTranslation } from 'react-i18next';
import { useCallback, useState } from 'react';
import { DATA_EXPORT_FILE_TYPE } from 'util/config/constant';
import { DATA_EXPORT_FILTER } from '../CleaningReportList/util/constant';

export const DataExportNavigation = ({ onClick }) => {
  const { t } = useTranslation();
  const [visiblePdf, setVisiblePdf] = useState(false);
  const [visibleXlsx, setVisibleXlsx] = useState(false);

  const handleVisibleChange = useCallback((fileType, value) => {
    if (fileType === DATA_EXPORT_FILE_TYPE.XLSX) {
      setVisibleXlsx(value);
    } else {
      setVisiblePdf(value);
    }
  }, []);

  const handleClickPopover = useCallback(
    (fileType, filterBy) => {
      setVisiblePdf(false);
      setVisibleXlsx(false);
      onClick(fileType, filterBy);
    },
    [onClick]
  );

  const renderPopoverContent = (fileType) => (
    <div className="no-select">
      <div className="popover-item">
        <RightOutlined />{' '}
        <span
          className="popover-title"
          data-testid="export-filtered-data"
          onClick={() =>
            handleClickPopover(fileType, DATA_EXPORT_FILTER.CONDITION)
          }
          aria-hidden="true">
          {t('exportCleaningReport.exportFilteredData')}
        </span>
      </div>

      <div className="popover-item">
        <RightOutlined />{' '}
        <span
          className="popover-title"
          data-testid="export-all-data"
          onClick={() => handleClickPopover(fileType, DATA_EXPORT_FILTER.ALL)}
          aria-hidden="true">
          {t('exportCleaningReport.exportAllData')}
        </span>
      </div>
    </div>
  );

  return (
    <div className="cleaningReports-export">
      <Popover
        content={renderPopoverContent(DATA_EXPORT_FILE_TYPE.XLSX)}
        trigger="click"
        visible={visibleXlsx}
        onVisibleChange={() => handleVisibleChange(DATA_EXPORT_FILE_TYPE.XLSX)}
        placement="bottomRight">
        <XLSX
          className="cleaningReports-export_icon"
          data-testid="export-xlsx"
        />
      </Popover>

      <Popover
        className="ml-4"
        content={renderPopoverContent(DATA_EXPORT_FILE_TYPE.PDF)}
        trigger="click"
        visible={visiblePdf}
        onVisibleChange={() => handleVisibleChange(DATA_EXPORT_FILE_TYPE.PDF)}
        placement="bottomRight">
        <PDF className="cleaningReports-export_icon" data-testid="export-pdf" />
      </Popover>
    </div>
  );
};

DataExportNavigation.propTypes = {
  onClick: PropTypes.func.isRequired
};
